import { Modal } from "reactstrap";
import CommonModal from './common-modal';

function ModernModal(props) {
    const {
        showModal,
        closeModal,
        setData,
        modalClassName,
        isToggle = true,
        modalMinWidth = "372px",
        modalMaxWidth = "372px",
    } = props;
    return (
        <Modal
            isOpen={showModal}
            className="no-cursor modern-modal"
            modalClassName={modalClassName}
            toggle={isToggle ? () => {
                closeModal(setData);
            } : null}
            style={{ minWidth: modalMinWidth, modalMaxWidth: modalMaxWidth }}
        >
            <CommonModal {...props} />
        </Modal>
    )
}

export default ModernModal